import React, { useState, useEffect } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../utils/firebase";
import Menu from "../../components/features/Menu/Menu";
import MenuFilters from "../../components/features/MenuFilter";
import Dashboard from "../../components/features/Dashboard";
import DashboardVentes from "../../components/features/DashboardVentes";
import DashboardAnalytics from "../../components/features/DashboardAnalytics";
import { useSearchParams } from "react-router-dom";

const DashboardCharts: React.FC = () => {
  const [selectedView, setSelectedView] = React.useState("Dashboard");

  const [salesData, setSalesData] = useState<any[]>([]);
  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (!user) return;
      const allSales: any[] = [];
      const clientsSnap = await getDocs(
        collection(db, "users", user.uid, "clients")
      );
      for (const clientDoc of clientsSnap.docs) {
        const projRef = collection(clientDoc.ref, "projects");
        const projQuery = query(projRef, where("Montant", "!=", null));
        const projSnap = await getDocs(projQuery);
        projSnap.docs.forEach((p) =>
          allSales.push({ id: p.id, clientId: clientDoc.id, ...p.data() })
        );
      }
      setSalesData(allSales);
    });
    return () => unsubscribe();
  }, []);

  // Helper to convert Firestore Timestamp or string to JS Date
  const toDate = (raw: any): Date | null => {
    if (!raw) return null;
    if (raw.seconds !== undefined && raw.nanoseconds !== undefined) {
      return new Date(raw.seconds * 1000);
    }
    const d = new Date(raw);
    return isNaN(d.getTime()) ? null : d;
  };

  const processedData = salesData.map((p) => {
    const amount =
      typeof p.Montant === "string"
        ? parseFloat(p.Montant.replace(/[^\d.-]/g, "")) || 0
        : Number(p.Montant) || 0;
    const paymentDate = toDate(p["Date de paiement"]);
    const startDate = toDate(p["Début du projet"]);
    const endDate = toDate(p["Fin du projet"]);
    return {
      ...p,
      amount,
      paymentDate,
      startDate,
      endDate,
    };
  });

  const [searchParams, setSearchParams] = useSearchParams();

  React.useEffect(() => {
    const type = searchParams.get("type");
    if (type) {
      setSelectedView(type);
    }
  }, [searchParams]);

  function handleSelect(option: string) {
    switch (option) {
      case "Dashboard":
        return <Dashboard data={processedData} />;
      case "Ventes":
        return <DashboardVentes data={processedData} />;
      case "Analyses":
        return <DashboardAnalytics data={processedData} />;
      default:
        return <Dashboard data={processedData} />;
    }
  }

  return (
    <div className="flex w-screen h-screen bg-gray-100">
      <Menu />
      <div className="flex flex-col gap-8 h-full w-full bg-gray-100 p-8 max-h-screen overflow-auto">
        <div className="flex flex-col w-full justify-between gap-8">
          <div className="flex items-center justify-between">
            <h1 className="text-3xl font-semibold">Revenus & Dépenses</h1>
            <button className="bg-black text-white px-4 py-2 rounded">
              Compléter mes données{" "}
            </button>
          </div>

          <MenuFilters
            selectedType={selectedView}
            setSelectedType={(e) => {
              setSelectedView(e);
            }}
          />
        </div>
        {handleSelect(selectedView)}
      </div>
    </div>
  );
};

export default DashboardCharts;
